import React from 'react';
import NavLink from './NavLink';

const QuickLinks: React.FC = () => {
    const links = [
        { href: '/catalog', text: 'Catalogue produits' },
        { href: '/about', text: 'À propos' },
        { href: '/contact', text: 'Contact' },
        { href: '/terms', text: 'Conditions de vente' },
        { href: '/privacy', text: 'Politique de confidentialité' }
    ];

    return (
        <div>
            <h3 className="links-container-title">Liens rapides</h3>
            <div className="links-container">
                {links.map((link, index) => (
                    <NavLink key={index} href={link.href} text={link.text} />
                ))}
            </div>
        </div>
    );
};

export default QuickLinks;
